import React from "react";
import { BasicModal } from "~/shared/ui/modals/BasicModal";
import { Stack } from "@mui/material";
import { IModalAddAccountProps } from "~/shared/types/types";


const ModalAddAccount: React.FC<IModalAddAccountProps> = React.memo(
    ({ isOpen, handleOpen, handleClose, title_button, children, buttonIcon }) => (
        <Stack display="flex" flexDirection="column" justifyContent="space-between">
            <BasicModal
                title_button={title_button}
                isIcon
                buttonIcon={buttonIcon}
                open={isOpen}
                handleOpen={handleOpen}
                handleClose={handleClose}>
                {children}
            </BasicModal>
        </Stack>
    ),
);

export default ModalAddAccount
